import React from 'react'
import styled from 'styled-components'
import { Link } from '../utils/SmartLink'

const LinkSurrogate = ({ fontSize, ...props }) => <Link {...props} />

const StylishLink = styled(LinkSurrogate)`
  text-align: center;
  display: block;
  font-size: ${props => props.fontSize || 1}rem;
  font-family: ${props => props.theme.headerFontFamily};
`

const StylishText = styled.div`
  text-align: center;
  display: block;
  font-size: ${props => props.fontSize || 1}rem;
  font-family: ${props => props.theme.headerFontFamily};
`

export const CenterLink = ({ fontsize, label, href }) => {
  if (!href) {
    return <StylishText fontSize={fontsize}>{decodeURI(label)}</StylishText>
  }
  return <StylishLink fontSize={fontsize} to={href} >{decodeURI(label)}</StylishLink>
}
